import { Settings, User, Bell, Shield, Palette } from 'lucide-react'
import { PageHeader, Card, Button } from '@/components/ui'

export function SettingsPage() {
  return (
    <div className="page-container">
      <PageHeader
        title="Pengaturan"
        description="Kelola akun, notifikasi, dan preferensi aplikasi."
      />

      <div className="max-w-2xl space-y-4">
        {[
          { id: 'settings-profile',  icon: User,     label: 'Profil Akun',       desc: 'Nama, email, dan informasi akun.' },
          { id: 'settings-security', icon: Shield,    label: 'Keamanan',          desc: 'Ganti password dan kelola sesi.' },
          { id: 'settings-notif',    icon: Bell,      label: 'Notifikasi',        desc: 'Preferensi alert dan reminder.' },
          { id: 'settings-display',  icon: Palette,   label: 'Tampilan',          desc: 'Tema dan preferensi visual.' },
        ].map(({ id, icon: Icon, label, desc }) => (
          <Card key={id} hoverable>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-slate-700/50 border border-slate-600/50 flex items-center justify-center">
                  <Icon size={16} className="text-slate-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-200">{label}</p>
                  <p className="text-xs text-slate-500">{desc}</p>
                </div>
              </div>
              <Button id={id} variant="ghost" size="sm">Kelola</Button>
            </div>
          </Card>
        ))}
      </div>

      <p className="text-[10px] text-slate-700">Pengaturan akun diimplementasi di Phase 3</p>
    </div>
  )
}
